export function normalizeSkillList(skills: unknown): string[] {
  if (!Array.isArray(skills)) return [];
  return skills
    .map((skill) => {
      if (typeof skill === 'string') return skill.trim();
      if (skill && typeof skill === 'object') {
        const record = skill as { name?: string; title?: string };
        return (record.name ?? record.title ?? '').trim();
      }
      return '';
    })
    .filter(Boolean);
}

export function uniqSkills(skills: string[]): string[] {
  return Array.from(new Set(skills.map((s) => s.trim()).filter(Boolean)));
}

export function skillsNotIn(saved: string[], candidates: string[]): string[] {
  const savedSet = new Set(saved);
  return candidates.filter((s) => !savedSet.has(s));
}
